import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import EmbeddedType from 'flow/types/embedded-type';
import { isFromSocialIntegration } from 'flow/utils/calendar-utils';
import { Calendar } from 'flow/types/Calendar';
import { TypedMap } from 'flow/types/TypedMap';
import SettingsBlock from '../settings/SettingsBlock';
import CalendarAutomeetingToggle from './CalendarAutomeetingToggle';
import RouteLink from '../ui-components/RouteLink';
import { useRouteMatch } from 'react-router-dom';

interface Props {
    calendar: TypedMap<Calendar>;
    updateCalendar: (calendarEvent: object) => void;
}

const CalendarExternal = ({ calendar, updateCalendar }: Props) => {
    const { i18next, embedded } = useAppContext();
    const match = useRouteMatch();

    const renderIntroSection = (isSocialIntegrationCalendar: boolean) => {
        if ([EmbeddedType.IOS, EmbeddedType.ANDROID].includes(embedded)) {
            return null;
        }

        const socialIntegrationText = isSocialIntegrationCalendar
            ? i18next.t('calendar.other.external.socialintegrationlogout')
            : undefined;
        const connectAccountText =
            !isSocialIntegrationCalendar && !calendar.has('url')
                ? i18next.t('calendar.other.external.connect_account')
                : undefined;

        return (
            <SettingsBlock>
                <div className="flex items-center p-3 text-xs text-gray-700">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: connectAccountText || socialIntegrationText,
                        }}
                    />
                </div>
            </SettingsBlock>
        );
    };

    const automeetingText = isFromSocialIntegration(calendar)
        ? i18next.t(
              'calendar.other.external.automeeting_socialintegration_info',
          )
        : i18next.t('calendar.other.external.automeeting_ical_info');

    return (
        <div>
            {isFromSocialIntegration(calendar) ? null : (
                <RouteLink to={`${match.url}/url`}>
                    {i18next.t('calendar.other.external.url')}
                </RouteLink>
            )}

            {renderIntroSection(isFromSocialIntegration(calendar))}

            <CalendarAutomeetingToggle
                calendar={calendar}
                toggleAutoMeeting={(value: boolean) => {
                    updateCalendar(calendar.set('autoMeeting', value));
                }}
                disabled={!calendar.has('url')}
                secondary={automeetingText}
            />
        </div>
    );
};

export default CalendarExternal;
